<template>
  <Dialog :open="open" @close="emit('close')" class="author-message-dialog">
    <div
      class="fixed inset-0 bg-black bg-opacity-25 dark_bg-opacity-40"
      aria-hidden="true"
    ></div>
    <div class="fixed inset-0 overflow-y-auto">
      <div class="flex min-h-full items-center justify-center p-4">
        <DialogPanel
          class="author-message-dialog-panel pending-review-dialog-panel w-full max-w-[592px] rounded-xl bg-white dark_bg-gray-800 shadow-xl flex flex-col gap-5 p-6 pt-6 text-left"
        >
          <p class="text-base leading-5 text-gray-900 dark_text-gray-100">
            <span class="font-semibold">{{ title }}</span>
            <template v-if="message">
              <br />
              <br />
              <span
                class="font-normal text-sm leading-5 text-gray-700 dark_text-gray-300"
              >
                {{ message }}
              </span>
            </template>
          </p>
          <div v-if="actions.length" class="flex justify-end w-full gap-2.5">
            <button
              v-for="action in actions"
              :key="action.label"
              type="button"
              class="inline-flex items-center justify-center gap-2 rounded-lg px-3 py-1.5 text-sm font-medium transition-colors focus_outline-none focus-visible_ring-2 focus-visible_ring-indigo-500 focus-visible_ring-offset-2"
              :class="
                action.primary
                  ? 'bg-indigo-600 text-white hover_bg-indigo-500 dark_bg-indigo-600 dark_hover_bg-indigo-500'
                  : 'border border-indigo-500 text-indigo-500 dark_text-indigo-400 dark_border-indigo-400 hover_bg-indigo-50 dark_hover_bg-indigo-900/20'
              "
              @click="action.onClick"
            >
              {{ action.label }}
            </button>
          </div>
        </DialogPanel>
      </div>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import { Dialog, DialogPanel } from '@headlessui/vue';
import type { AuthorDialogAction } from '../lib/useMessageDialog';

withDefaults(
  defineProps<{
    open: boolean;
    title?: string;
    message?: string;
    actions?: AuthorDialogAction[];
  }>(),
  { title: '', message: '', actions: () => [] }
);

const emit = defineEmits<{ (e: 'close'): void }>();
</script>
